import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Sem lacticínios',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Picante',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegan',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Sem glúten',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetariano',
};
